import { ICompanyAutocomplete } from 'features/Companies/components/MultiCompanyAutocomplete'
import { IAccessToken } from 'features/Login/types'
import { isSuperAdmin } from 'features/Users/utils'

export const canSelectCompany = (accessToken: IAccessToken): boolean => {
  return isSuperAdmin(accessToken.conditions) || (accessToken.companyIds?.length || 1) > 1
}

export const getDefaultCompanyForForm = (accessToken: IAccessToken): ICompanyAutocomplete => {
  if (!canSelectCompany(accessToken)) {
    return {
      id: accessToken.companyIds?.[0] || '',
      name: ''
    }
  }

  return {
    id: '',
    name: ''
  }
}

export const getDefaultCompaniesForForm = (accessToken: IAccessToken): ICompanyAutocomplete[] => {
  if (!canSelectCompany(accessToken)) {
    return [getDefaultCompanyForForm(accessToken) as ICompanyAutocomplete]
  }

  return []
}
